import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';

import img from './img.png';
import styles from './styles.module.scss';

function GiftHeader() {
  return (
        <Column align='center' fullWidth
                spacing={32}
                className={styles.container}>
            <Image src={img}
                   className={styles.image}
                   width={224}
                   alt='' />
            <Text size='3xl' fontWeight='bold'>
                김찡찡님이 보낸 선물입니다.
            </Text>
        </Column>
  );
}

export default GiftHeader;
